import React from 'react';
import { Autocomplete } from '@react-google-maps/api';
import { AppBar, Toolbar, Typography, InputBase, Box,Avatar,Menu,MenuItem } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useAuth } from '../../context/AuthContext.js';
import useStyles from './styles.js';
const Header = ({ onPlaceChanged, onLoad }) => {
  const classes = useStyles();
  const {login,signout,currentUser} = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <AppBar position="static" style={{"background" : "black"}}>
      <Toolbar className={classes.toolbar}>
        <Typography variant="h5" className={classes.title}>
          Travel Advisor
        </Typography>
        <Box className={classes.headerBox} display="flex" width="70%" justifyContent="flex-end">
          <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase placeholder="Search…" classes={{ root: classes.inputRoot, input: classes.inputInput }} />
            </div>
          </Autocomplete>
          <Avatar aria-controls="simple-menu" aria-haspopup="true"  onClick={(!currentUser) ? login : handleClick}  className={classes.userAvatar}  src={currentUser?.photoURL} justifyContent="flex-end"/>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            style={{ top:'38px', }}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={handleClose}>My account</MenuItem>
            <MenuItem onClick={signout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
